module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"type-filter":"Type Filter"}}')
  delete Component.options._Ctor
}
